export const getCurrentDate = () => {
    const currentDate = new Date();

    const dkMonth = currentDate.toLocaleString('da-DK', { month: 'short' });
    const newDkMonth = dkMonth.split('.').join(' ');
    return currentDate.getDate() + '. ' + newDkMonth + '' + currentDate.getFullYear();
};

export const addDays = (date: Date, days: number): Date => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
};
